__turbopack_context__.v({
  "tag": "EventTag-module-scss-module__PtoB-a__tag",
});
